// We're getting a bunch of html from the server and shoving it into react here.

import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Link as RouterLink} from 'react-router-dom';

import {api} from 'nutshell-core/api';

import {headTitle} from 'shells/document/head-title';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconSetupIcon} from 'shells/icon/svg/sidebar-icon-setup';
import {MainContentContainer} from 'shells/layout/main-content-container';
import {Link} from 'shells/link/link';

import {setBodyId} from '../../dom';

import {PageTitleBar} from '../layout';

type Props = {
    emailId: string;
    isTicketMessage?: boolean;
};

export class EmailPage extends React.Component<Props> {
    componentDidMount() {
        setBodyId('email');
        const controller = this.props.isTicketMessage ? 'ticketmessages' : 'emails';
        const apiType = this.props.isTicketMessage ? 'ticketMessages' : 'emails';
        const apiId = `${this.props.emailId}-${apiType}`;

        api.get(`/${controller}/${apiId}`)
            // @ts-expect-error
            .then((res) => res.json())
            .then((res) => Nut.RestService.parseTopLevelResponse(res))
            .then(() => {
                const model = Nut.Model.getModel({
                    id: apiId,
                    type: apiType,
                });

                const view = Nut.View.timelineEvent.createViewForModel(model, {
                    detailView: true,
                    displayComments: true,
                });
                $('#entry-container .timeline3-entry').replaceWith(view.$el);
            })
            .then(() => {
                api.post(`views/${apiId}`, {});
            });
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>
                        {headTitle(`${this.props.isTicketMessage ? 'Ticket' : 'Email'} details`)}
                    </title>
                </Helmet>

                <MainContentContainer whiteBackground={true}>
                    <PageTitleBar
                        title='Email'
                        subheaderPrimaryText='All your messages in one place'
                        buttons={
                            <Link
                                variant='button-secondary'
                                // @ts-expect-error
                                as={RouterLink}
                                to='/my-account/email-sending'
                                size='big'
                                icon={SidebarIconSetupIcon}
                            >
                                Email settings
                            </Link>
                        }
                    />
                    <div id='entry-container' className='timeline3-list variant-full'>
                        <div className='timeline3-entry state-expanded type-email' />
                        <div className='timeline3-end'>
                            <div className='line' />
                            <div className='dot' />
                        </div>
                    </div>
                </MainContentContainer>
            </React.Fragment>
        );
    }
}
